import { createSlice } from '@reduxjs/toolkit';

const REDUCER_NAME = 'modal';

const initialState = {
  isOpen: false,
  name: '',
  meta: {},
};

export const appSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    openModal: (state, action) => {
      const { name, meta = {} } = action.payload;
      state.name = name;
      state.meta = meta;
      state.isOpen = true;
    },
    closeModal: (state) => {
      state.name = '';
      state.meta = {};
      state.isOpen = false;
    },
  },
});

export const { actions, reducer } = appSlice;
export const { openModal, closeModal } = actions;

const selectSelf = (state) => state[REDUCER_NAME];

export const selectIsModalOpen = (state) => selectSelf(state).isOpen;
export const selectModalName = (state) => selectSelf(state).name;
export const selectModalMeta = (state) => selectSelf(state).meta;
export const selectModalState = (state) => ({
  isOpen: selectIsModalOpen(state),
  name: selectModalName(state),
  meta: selectModalMeta(state),
});

export default reducer;
